
























import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
import { asociacionEventBus } from '@/setup';
import FormServer1Streamax from './ServerStreamax/FormServer1Streamax.vue';
import FormServer2Streamax from './ServerStreamax/FormServer2Streamax.vue';
import FormServer3Streamax from './ServerStreamax/FormServer3Streamax.vue';
@Component({
  components: {
    'app-confirmacion': Confirmation,
    FormServer1Streamax,
    FormServer2Streamax,
    FormServer3Streamax,
  },
})
export default class FormEditarSetupStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  show: boolean = true;
  accion!: any;
  ordesList2: any;
  items: any[] = [
    { index: 0, tab: 'Server 1', content: 'FormServer1Streamax' },
    { index: 1, tab: 'Server 2', content: 'FormServer2Streamax' },
    { index: 2, tab: 'Server 3', content: 'FormServer3Streamax' },
  ];
  tab: any = null;
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
}
